// user stote
import authService from '../../services/auth'
const state = ()=>({
  list: {
    name:'sandeep',email:'sandeep@musecomm.in',subscribed:false
  }
})
const getters = {
  list: state => state.list,
}

// actions
const actions = {
  fetchUsers({commit}){
    return new Promise((resolve, reject) => {
      authService.getUsers()
      .then(resp => {
        const userlist = resp.data.user
        commit('fetch_user', userlist)
        resolve(resp)
      })
      .catch(err => {
        commit('user_error')
        reject(err)
      })
    })
},
}

// mutations
const mutations = {
  fetch_user(state, user){
    state.list=user
},
user_error(state){
  state.list=''
}
}

export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
